/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrizeClaimRequestBody
 */
export interface PrizeClaimRequestBody {
    /**
     * The Solana transaction signature for the 2 YAK payment
     * @type {string}
     * @memberof PrizeClaimRequestBody
     */
    signature: string;
    /**
     * The wallet address that sent the transaction
     * @type {string}
     * @memberof PrizeClaimRequestBody
     */
    wallet: string;
}

/**
 * Check if a given object implements the PrizeClaimRequestBody interface.
 */
export function instanceOfPrizeClaimRequestBody(value: object): value is PrizeClaimRequestBody {
    let isInstance = true;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "wallet" in value && value["wallet"] !== undefined;

    return isInstance;
}

export function PrizeClaimRequestBodyFromJSON(json: any): PrizeClaimRequestBody {
    return PrizeClaimRequestBodyFromJSONTyped(json, false);
}

export function PrizeClaimRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizeClaimRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signature': json['signature'],
        'wallet': json['wallet'],
    };
}

export function PrizeClaimRequestBodyToJSON(value?: PrizeClaimRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signature': value.signature,
        'wallet': value.wallet,
    };
}

